export const tooltips =
{
  "Action" : "Click to add this action to the currently selected button.",
  "ButtonSelector" : "Click to select button for editing",
  "DocumentTitle" : "Enter preset name here",
  "NewDocument" : "Clear the current settings and start from scratch",
  "OpenDocument" : "Open up a .dlcfg file to load in your settings",
  "SaveDocument" : "Save your configuration settings to your hard drive",
  "Connect" : "Click here to make a connection attempt",
  "Settings" : "Enter global settings",
  "Panic" : "Reset your looper back to default settings",
  "FilterBar" : "Search for actions here",
  "Upload" : "Send current program (all presets) to DataLooper",
  "Download" : "Receive current program (all presets) from DataLooper",
  "CopyPreset" : "Copy current preset"
}

export const Modals = 
{
  "NewDocument" : "Are You Sure?",
  "CopyPreset" : "Copy Current Preset",
  "Syncing" : "Syncing Config",
  "Download" : "Are You Sure? Downloading will overwrite current config."
}